import React from 'react';
import { Input } from 'antd';
let Password = Input.Password
const InputPassword = ({value,placeholder}) =><Password 
placeholder={placeholder} 
value={value} />;

export default InputPassword;